import ApiService from './api.service';
import type { PipelineNodeRelationship } from '../hooks/usePipelineNodeRelationships';

export type SingleRecordResponse<T> = {
  record: T;
};

export class PipelineNodeRelationshipService {
  async save(relationship: Partial<PipelineNodeRelationship>): Promise<PipelineNodeRelationship> {
    const result = await ApiService.getInstance().request(
      relationship.id ? 'PATCH' : 'POST',
      relationship.id ? `/pipelinenoderelationships/${relationship.id}` : '/pipelinenoderelationships',
      relationship
    ) as SingleRecordResponse<PipelineNodeRelationship>;
    return result.record;
  }

  async delete(relationshipId: string): Promise<void> {
    await ApiService.getInstance().request(
      'DELETE',
      `/pipelinenoderelationships/${relationshipId}`
    );
  }
}

export const pipelineNodeRelationshipService = new PipelineNodeRelationshipService();

